import React from 'react';
import {FieldTable} from '../../components/FieldTable/FieldTable';
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import {ModalWindow} from "../../components/ModalWindow";
import {Button} from "@mui/material";

const columns:FieldTableColumnProps<any>[] = [
    {
        accessor: 'campaign.name',
        header: 'Campaign name',
        dataType:'default'
        // eslint-disable-next-line react/display-name
    },{
        header: 'From',
        accessor: 'first_week',
        dataType:'date',
        readOnly:()=>true
    },{
        accessor: 'last_week',
        header: 'To',
        dataType:'date',
        readOnly:()=>true
    },{
        accessor: 'panel.site.name',
        header: 'Site Name',
        dataType:'default',
        exportOnly: true,
        readOnly:()=>true
    },{
        accessor: 'campaign.ourContact.name',
        // eslint-disable-next-line react/display-name, react/prop-types
        dataType:'link',
        options: {
            getLink: ({row}) => ('mailto:' + row?.campaign?.ourContact?.email)
        },
        header: 'Contact'
    }
];


const AffectedBookingsDialog = ({name,isOpen,affectedBookings,onAccept,onCancel})=> {
    

    return (<ModalWindow className="affected-bookings__modal" maxWidth="md" isOpen={isOpen} onClose={onCancel} header={
        <>{""+(affectedBookings.length)+" bookings would be affected by changes to "+name}</>
    } actions={
    <>
        <Button onClick={onAccept} color="warning">Save anyway</Button>
        <Button onClick={onCancel} variant="contained">Cancel</Button>
    </>
    }>
        <FieldTable loading={false} className="affected-bookings__table is-scrollable" columns={columns} hasDelete={false} values={affectedBookings} />
    </ModalWindow>);

}

export default AffectedBookingsDialog;